import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Checkbox, Stack, Input} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    ADD_FILTER,
    REMOVE_FILTER
} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils'

const CheckboxRefinements = ({filter, toggleFilter, selectedFilters, onCheckedChange}) => {
    const {formatMessage} = useIntl()
    const [searchTerm, setSearchTerm] = useState('')

    const filteredValues = filter.values?.filter((value) =>
        value.label?.toLowerCase().includes(searchTerm.toLowerCase())
    )

    return (
        <Stack spacing={3}>
            {filter?.values?.length > 10 && (
                <Input
                    className="series-search"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    variant="unstyled"
                    size="sm"
                    boxShadow="inset 0 -1px 0 #ddd"
                    padding=".375rem .75rem"
                    _focus={{
                        color: '#495057',
                        borderColor: 'rgb(96.5, 210.421875, 255)',
                        outline: '0',
                        boxShadow: '0 0 0 .2rem rgba(0, 161, 224, .25)'
                    }}
                    borderRadius="0"
                    fontSize="sm"
                    marginLeft="5px"
                />
            )}

            {filteredValues?.map((value) => {
                const isChecked = selectedFilters.includes(value.value)

                if (value.hitCount === 0 && !isChecked) return null

                return (
                    <Box key={value?.value}>
                        <Checkbox
                            isChecked={isChecked}
                            onChange={() => {
                                toggleFilter(value, filter.attributeId, isChecked)
                                onCheckedChange?.(isChecked)
                            }}
                            aria-label={formatMessage(
                                isChecked ? REMOVE_FILTER : ADD_FILTER,
                                value
                            )}
                            className="custom-check-box"
                            px={'3px'}
                        >
                            {`${value.label ?? ''}${
                                value?.hitCount !== undefined ? ` (${value.hitCount})` : ''
                            }`}
                        </Checkbox>
                    </Box>
                )
            })}
        </Stack>
    )
}

CheckboxRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array,
    onCheckedChange: PropTypes.func
}

export default CheckboxRefinements
